/**
 * Loads one version of the recommendation rules (the latest published one by default) for the 规则
 * tab, telling a denial (not a Deal Desk admin — retrying cannot help) apart from other failures.
 */
import { useCallback, useEffect, useState } from 'react';

import { GetRecommendationRulesCommand, getCpaClient, type RuleVersionData } from '../client/CpaClient';
import { isAccessDenied } from '../utils/programs';

export type RulesState =
  | { kind: 'loading' }
  | { kind: 'ready'; rules: RuleVersionData }
  | { kind: 'denied' }
  | { kind: 'error'; message: string };

export function useRecommendationRules(version?: number): { state: RulesState; reload: () => void } {
  const [state, setState] = useState<RulesState>({ kind: 'loading' });

  const reload = useCallback(() => {
    setState({ kind: 'loading' });
    getCpaClient()
      .send(new GetRecommendationRulesCommand({ version }))
      .then((out) => setState({ kind: 'ready', rules: out.rules! }))
      .catch((e: unknown) =>
        setState(
          isAccessDenied(e)
            ? { kind: 'denied' }
            : { kind: 'error', message: e instanceof Error ? e.message : String(e) },
        ),
      );
  }, [version]);

  useEffect(reload, [reload]);

  return { state, reload };
}
